<div class="d-flex mb-3">
  <span class="flex-grow-1 my-auto">
    {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.fields-assignments' | translate}}
  </span>
  @if(canShowSaveButton){
    <button type="button"
            class="btn btn-outline-warning me-3"
            (click)="saveToTemplate()">
      {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.button-assignment-as-template' | translate}}
    </button>
  }
  @if(showTemplateButtons && canEditConfiguration){
    <button type="button"
            class="btn btn-outline-success me-3"
            (click)="loadFromTemplate()">
      {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.button-assignment-from-template' | translate}}
    </button>
  }
  @if(canEditConfiguration){
    <span class="e-icons icon-add e-icon-big my-auto"
          (click)="this.grid.addRecord()"
          title="{{ 'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.add-button-tooltip' | translate }}">
    </span>
  }
</div>
<ejs-grid #grid
          width="100%"
          rowHeight="38"
          [dataSource]="data"
          [allowSorting]="true"
          [allowFiltering]="true"
          [allowPaging]="false"
          [filterSettings]="filterSettings"
          [pageSettings]="pageSettings"
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          [allowRowDragAndDrop]='true'
          [selectionSettings]='selectOptions'
          (commandClick)="commandClicked($event)"
          (actionBegin)="actionBegin($event)"
          (actionComplete)="actionComplete($event)">
  <e-columns>
    <e-column field="id"
              [visible]="false"
              [isPrimaryKey]="true"></e-column>
    <e-column field="sourceName"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.source' | translate}}"
              clipMode="EllipsisWithTooltip"
              type="string">
    </e-column>
    <e-column field="targetName"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.target' | translate}}"
              clipMode="EllipsisWithTooltip"
              type="string">
    </e-column>
    <e-column field="overwriteCurrency"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.currency' | translate}}"
              clipMode="EllipsisWithTooltip"
              [filter]="checkboxFilter">
              <ng-template #filterItemTemplate let-data>{{getCurrencyString(data.overwriteCurrency) | translate}}</ng-template>
              <ng-template #template let-data>
                <span>{{getCurrencyString(data.overwriteCurrency) | translate}}</span>
              </ng-template>
    </e-column>
    <e-column field="fixValue"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.static-value' | translate}}"
              clipMode="EllipsisWithTooltip"
              type="string">
    </e-column>
    <e-column field="cap"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.cap-from-short' | translate}}"
              clipMode="EllipsisWithTooltip"
              type="string">
    </e-column>
    <e-column field="exportZeroValueAsEmpty"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.non-zero-values-short' | translate}}"
              clipMode="EllipsisWithTooltip"
              [filter]="checkboxFilter">
      <ng-template #filterItemTemplate let-data>{{formatNullValueFilter(data) | translate}}</ng-template>
      <ng-template #template let-data>
        @if(data.exportZeroValueAsEmpty){
          <div class="e-icons icon-checkmark align-middle"></div>
        }
      </ng-template>
    </e-column>
    <e-column headerText=""
              [commands]="gridCommands"></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate
               let-data>
    <app-field-assignment-entry-form [fieldAssignmentEditForm]="gridEditForm">
    </app-field-assignment-entry-form>
  </ng-template>
</ejs-grid>
